import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { openCart } from '../../redux/cart/actions';

const OpenCartButton = (props) => {
  let count = 0;
  const { items, openCart } = props;
  items.forEach((item) => {
    count += Number(item.quantity);
  });
  return (
    <div>
      <button className="page-header__cart-btn page-header__icon" type="button" onClick={openCart}>
      <svg className="icon-cart" width="20" height="17" aria-hidden="true" focusable="false" role="presentation" fill="none">
        <use href="#icon-cart" />
      </svg>
        {count > 0 && (
          <span>
            {count}
          </span>
        )}
      </button>
    </div>
  );
};

OpenCartButton.propTypes = {
  // text: PropTypes.string.isRequired,
};

const mapDispatchToProps = {
  openCart,
};

const mapStateToProps = (state) => ({
  items: state.cart.items,
});

OpenCartButton.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  openCart: PropTypes.func.isRequired,
};

OpenCartButton.defaultProps = {
  items: [],
};

export default connect(mapStateToProps, mapDispatchToProps)(OpenCartButton);
